const initialState = {
	loading: false,
	error: null,
	checkIns: null,
	selected: null,
	single_loading: false // for when modal is open
}

const checkIns = (state = initialState, action) => {
	switch (action.type) {
		case 'CHECKIN_LOADING': {
			return {
				...state,
				single_loading: true
			}
		}
		case 'CHECKIN_NOT_LOADING': {
			return {
				...state,
				single_loading: false
			}
		}
		case 'REPLACE_CHECKIN': {
			return {
				...state,
				checkIns: state.checkIns.map((c) => {
					if (c._id === action.payload._id) {
						return {
							...action.payload
						}
					}
					return c
				})
			}
		}
		case 'GUEST_SIGNED': {
			return {
				...state,
				checkIns: state.checkIns.map((c) => {
					if (c._id === action.payload.checkIn._id) {
						return {
							...c,
							guests: c.guests.map((g) => {
								if (g.name === action.payload.guest.name) {
									return {
										...g,
										signed_waiver: g.signed_waiver ? false : true
									}
								}
								return g
							})
						}
					} else {
						return c
					}
				})
			}
		}
		case 'GET_CHECKINS':
			return { ...state, loading: true, single_loading: true }
		case 'SET_CHECKINS':
			return {
				...state,
				loading: false,
				single_loading: false,
				checkIns: action.payload
			}
		case 'GET_CHECKINS_FAIL':
			return { ...state, loading: false, error: action.payload }
		case 'ADDING_CHECKIN':
			return { ...state, loading: true }
		case 'ADDING_CHECKIN_SUCCESS':
			return {
				...state,
				loading: false,
				checkIns:
					state.checkIns && state.checkIns.length
						? [...state.checkIns, action.payload]
						: [action.payload],
				error: null
			}
		case 'ADDING_CHECKIN_FAILURE':
			return {
				...state,
				loading: false,
				error: action.payload || 'An error occured while adding an check-in.'
			}
		case 'REMOVE_CHECKIN_SUCCESS':
			return {
				...state,
				loading: false,
				checkIns:
					state.checkIns && state.checkIns.length && action.payload
						? state.checkIns.filter((checkIn) => checkIn._id !== action.payload)
						: state.checkIns,
				error: null
			}
		case 'CLEAR_CHECKINS':
			return { ...state, checkIns: null, loading: false, error: null }
		default:
			return state
	}
}

export default checkIns
